// SARKY deterministic mobile purchase bar (snippets/sarky-mobile-purchase-bar.liquid).
// This file owns no variant-selection state of its own -- it only (1)
// proxies a tap on its own Add to Bag button to the real product-form's
// Add to Cart button (identical pattern to the existing, unmodified
// assets/sticky-add-to-cart.js#handleAddToCartClick, so there is exactly
// one real submit path), and (2) mirrors the currently resolved variant
// into its own left-segment text + right-button disabled state, reacting
// to the same native 'variant:update' event assets/variant-picker.js
// already dispatches unmodified.
//
// The "Size just became invalid, must clear" case is owned entirely by
// the existing assets/sarky-clear-invalid-size.js (it already updates the
// native sticky bar the same way; this file's variant:update handler below
// only re-derives from the CURRENT DOM state -- not from event.detail
// directly -- so it renders correctly regardless of whether that file's
// listener has already run in this same event dispatch or not).
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const addButton = event.target.closest('.sarky-mobile-bar__add');
  if (!addButton) return;

  const bar = addButton.closest('.sarky-mobile-bar');
  const productId = bar && bar.dataset.productId;
  if (!productId) return;

  const productForm = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
  const mainAddToCartButton = productForm && productForm.querySelector('.add-to-cart-button');
  mainAddToCartButton?.click();
});

document.addEventListener('variant:update', (event) => {
  const productId = event.detail.data && event.detail.data.productId;
  if (!productId) return;

  const bar = document.querySelector(`.sarky-mobile-bar[data-product-id="${productId}"]`);
  if (!bar) return;

  const selectButton = bar.querySelector('.sarky-mobile-bar__select');
  const addButton = bar.querySelector('.sarky-mobile-bar__add');

  const picker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);
  const nonColorFieldsets = picker
    ? Array.from(picker.querySelectorAll('fieldset')).filter(
        (fieldset) => !fieldset.classList.contains('variant-option--swatches')
      )
    : [];

  const isFullySelected = nonColorFieldsets.every((fieldset) => {
    const checkedInput = fieldset.querySelector('input:checked');
    return checkedInput && checkedInput.getAttribute('aria-disabled') !== 'true';
  });

  if (selectButton) {
    selectButton.textContent = isFullySelected && event.detail.resource ? event.detail.resource.options.join(' · ') : 'Select Size';
  }

  if (addButton) {
    addButton.disabled = !isFullySelected || !event.detail.resource || event.detail.resource.available === false;
  }
});
